import "./Login.css";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../GlobalContext";

export default function Login() {
  const [kode, setKode] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const { api, loadUserData } = useGlobalContext();

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (loading) return;
    setLoading(true);
    setError("");

    const userkode = kode.trim();

    if (!userkode) {
      setError("Username wajib diisi.");
      setLoading(false);
      return;
    }

    if (!password) {
      setError("Password wajib diisi.");
      setLoading(false);
      return;
    }

    try {      
      //console.log(kode, password);

      const response = await api.post("/api/users/login", { kode, password }, {timeout: 10000,});

      const data = response?.data;

      console.log("Response dari server:", data);

      const pengguna = data?.data;

      localStorage.setItem("pengguna", JSON.stringify(pengguna));      

      await loadUserData();

      console.log("Login berhasil, data pengguna disimpan di localStorage:", pengguna);

      navigate("/dashboard",{ replace: true });
    } catch (err) {
      console.error("❌ Terjadi kesalahan saat login:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="brand">
          <h1>Koperasi</h1>
          <p>Bersama Kita Maju</p>
        </div>

        <div className="card-divider" />

        <h2>Selamat Datang</h2>
        <p className="welcome">Silakan masuk untuk melanjutkan</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <label>Username</label>

          <div className="input-box">
            <FaUser />
            <input
              type="text"
              placeholder="Masukkan username"
              value={kode}
              onChange={(ev) => setKode(ev.target.value)}
              required
            />
          </div>

          <label>Password</label>

          <div className="input-box">
            <FaLock />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Masukkan password"
              value={password}
              onChange={(ev) => setPassword(ev.target.value)}
              required
            />
            <span className="eye-btn" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="remember">
            <label>
              <input type="checkbox" />
              Ingat Saya
            </label>

            <a href="/">Lupa Password?</a>
          </div>

          <button className="btn-login" disabled={loading}>
            {loading ? "Loading..." : "Masuk"}
          </button>
        </form>
        </div>
    </div>
  );
}
